import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

const CHAT_HISTORY_CACHE_KEY = 'shopping-assistant-chat-history'

/**
 * Fetches the user's recent chats via useAsyncData (lazy, non-blocking).
 * Uses a shared cache key so all callers (Header, ChatHistoryModal,
 * ShoppingAssistantChat) share the same data — no provide/inject needed.
 *
 * Returns the raw useAsyncData shape (data, pending, error, refresh, …).
 * Pagination is not yet supported — the API returns all chats in a single
 * page with `previous: null` and `next: null`.
 */
export function useFetchShoppingAssistantChatHistory() {
  return useAsyncData(
    CHAT_HISTORY_CACHE_KEY,
    () => useHttpFetch()('/api/shopping-agent/v1/chats'),
    { lazy: true },
  )
}
